( function () {

  document.addEventListener( 'DOMContentLoaded', () => {
    const sections = document.querySelectorAll( '.schema-faq-section' );
    
    function collapseAll() {
      sections.forEach( section => {
        section.classList.remove( 'active' );
        const answer = section.querySelector( '.schema-faq-answer' );
        answer.style.height = '0px';
      } );
    }
    
    sections.forEach( ( section, index ) => {
      const answer = section.querySelector( '.schema-faq-answer' );
      const question = section.querySelector( '.schema-faq-question' );
    
      // Setup transition
      answer.style.overflow = 'hidden';
      answer.style.transition = 'height 0.3s ease-in-out';
    
      // Expand first section by default
      if ( index === 0 ) {
        section.classList.add( 'active' );
        answer.style.height = answer.scrollHeight + 'px';
      } else {
        answer.style.height = '0px';
      }
    
      question.style.cursor = 'pointer';

      function toggle() {
        const isActive = section.classList.contains( 'active' );
        if ( isActive ) {
          section.classList.remove( 'active' );
          answer.style.height = '0px';
        } else {
          collapseAll();
          section.classList.add( 'active' );
          answer.style.height = answer.scrollHeight + 'px';
        }
      }

      question.addEventListener( 'click', ( e ) => {
        e.stopPropagation();
        toggle();
      } );
      
      section.addEventListener( 'click', ( e ) => {
        if ( e.target !== section ) return;
        const questionBottom = question.getBoundingClientRect().bottom;
        if ( e.clientY > questionBottom ) return;
        toggle();
      } );
    } );
    
    // Auto-adjust expanded panel height on window resize
    window.addEventListener( 'resize', () => {
      document.querySelectorAll( '.schema-faq-section.active .schema-faq-answer' )
        .forEach( answer => {
          answer.style.height = answer.scrollHeight + 'px';
        } );
    } );
  } );
} )();